<template>
  <div v-if="screenData" class="sub-view analysis-zone">
    <div :class="['sub-view-wrapper', activeAside && 'opened']">
      <div class="sub-view-gabarit">
        <div class="header-box">
          <h4>{{ $t('sections.impact') }}</h4>
        </div>
        <Filters />
        <AnalysisSection>
          <template #header>
            <h5>{{ $t('report.impactProportion') }}</h5>
          </template>
          <template #body>
            <Proportion :data="screenData" />
            <div class="proportion-legend">
              <div class="label improvement">
                {{ $t('improvement') }}
              </div>
              <div class="cercle"></div>
              <div class="label degradation">
                {{ $t('degradation') }}
              </div>
            </div>
          </template>
        </AnalysisSection>
        <AnalysisSection>
          <template #header>
            <h5>{{ $t('report.impactDetailAnalysis') }}</h5>
          </template>
          <template #body>
            <DetailsTable :data="screenData" />
          </template>
        </AnalysisSection>
        <AnalysisSection>
          <template #header>
            <h5>{{ $t('report.impactFocusImprovement') }}</h5>
          </template>
          <template #body>
            <FocusImprovement :data="screenData" />
          </template>
        </AnalysisSection>
        <AnalysisSection>
          <template #header>
            <h5>{{ $t('report.impactFocus') }}</h5>
          </template>
          <template #body>
            <FocusDecay :data="screenData" />
          </template>
        </AnalysisSection>
      </div>
      <FooterSection v-if="isDesktop" class="footer-section" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Analysis from './AnalysisMixin';
import Proportion from '@/components/Analysis/Impact/Proportion';
import DetailsTable from '@/components/Analysis/Impact/DetailsTable';
import FocusDecay from '@/components/Analysis/Impact/FocusDecay';
import FocusImprovement from '@/components/Analysis/Impact/FocusImprovement';
import FooterSection from '@/components/Footer';

export default {
  components: {
    Proportion,
    DetailsTable,
    FocusDecay,
    FocusImprovement,
    FooterSection,
  },

  mixins: [Analysis],

  computed: {
    ...mapGetters({
      isDesktop: 'isDesktop',
    }),
  },
};
</script>

<style lang="scss" scoped>
@use '@/styles/colors.scss';

.proportion-legend {
  width: calc(100% - 24px);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px 0;
  margin: 0 12px;
  border-top: solid 1px colors.$grey-color;

  .label {
    &.improvement {
      color: #1daea1;
    }
    &.degradation {
      color: colors.$red-color;
    }
  }
  .cercle {
    $radius: 20px;
    margin: 2px 8px;
    width: $radius;
    height: $radius;
    border-radius: $radius;
    border: solid 4px transparent;
    border-top-color: #1daea1;
    border-left-color: #1daea1;
    border-right-color: colors.$red-color;
    border-bottom-color: colors.$red-color;
    transform: rotate(-45deg);
  }
}
</style>
